function generateString(length) {
  let generatedString = '';
  const possibleChar =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

  for (let i = 0; i < length; i += 1)
    generatedString += possibleChar.charAt(
      Math.floor(Math.random() * possibleChar.length),
    );

  return generatedString;
}

export default generateString;
